import find from 'lodash/find';
import forOwn from 'lodash/forOwn';
import intersection from 'lodash/intersection';
import concat from 'lodash/concat';
import values from 'lodash/values';
import every from 'lodash/every';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';

export const getSupportPaymentMethods = ({
  paymentOptions, type, supportSubOptionConfig = {},
  paymentAmount, payManual, payInFull,
}) => {
  const paymentOption = find(paymentOptions, { type });
  if (!paymentOption) {
    return [];
  }
  const {
    supportPaymentMethods, subOptions = [],
    supportPaymentMethodsForManualPayment,
    supportPaymentMethodsForPayInFull,
  } = paymentOption;
  let mainSupportPaymentMethods = supportPaymentMethods;
  // hasCurrentDue just for PAY_MANUAL & PAY_IN_FULL
  const hasCurrentDue = paymentAmount > 0; // >0 is true, ===0 false, <0 have no this case
  if (type === 'PAY_DEPOSIT_WITH_PAYMENT_PLAN' && payManual) {
    const paymentMethodsOption = find(supportPaymentMethodsForManualPayment, { hasCurrentDue });
    mainSupportPaymentMethods = paymentMethodsOption?.supportPaymentMethods ?? [];
  }

  if (type === 'PAY_DEPOSIT_WITH_PAYMENT_PLAN' && payInFull) {
    const paymentMethodsOption = find(supportPaymentMethodsForPayInFull, { hasCurrentDue });
    mainSupportPaymentMethods = paymentMethodsOption?.supportPaymentMethods ?? [];
  }

  // subOptions is blank or all subOption values are false return supportPaymentMethods
  if (subOptions.length === 0 || every(values(supportSubOptionConfig), v => !!v === false)) {
    return mainSupportPaymentMethods;
  }

  let initSubSupportPaymentMethods = [];
  // if subSupportPaymentMethods is not [] take the intersection else take the concat.
  forOwn(supportSubOptionConfig, (value, key) => {
    const subObj = find(subOptions, { type: key });
    if (value && !!subObj) {
      const { supportPaymentMethods: subSupportPaymentMethods } = subObj;
      if (subSupportPaymentMethods.length === 0 || initSubSupportPaymentMethods.length === 0) {
        initSubSupportPaymentMethods = concat(initSubSupportPaymentMethods,
          subSupportPaymentMethods);
      } else {
        initSubSupportPaymentMethods = intersection(initSubSupportPaymentMethods,
          subSupportPaymentMethods);
      }
    }
  });
  return intersection(initSubSupportPaymentMethods, mainSupportPaymentMethods);
};

export const getAvaliblePaymentMethods = ({
  paymentOptions, currentActiveOption, supportSubOptionConfig = {},
  paymentAmount, payManual, payInFull,
}) => {
  if (isEmpty(paymentOptions)) {
    return [];
  }
  return getSupportPaymentMethods({
    paymentOptions,
    type: currentActiveOption,
    supportSubOptionConfig,
    paymentAmount,
    payManual,
    payInFull,
  });
};

export const isOnlyPayInfullWithoutSubOptions = (paymentOptions) => {
  return paymentOptions.length === 1 && paymentOptions[0].type === 'PAY_REMAINING_BALANCE' && isEmpty(paymentOptions[0].subOptions);
};

export const isPayInfull = (paymentPlanOptions) => {
  return every(paymentPlanOptions, ({ paymentPlanId }) => paymentPlanId === undefined);
};

export const isPayManual = (paymentPlanOptions) => {
  const paymentPlanOptionsExcludePayInFull = filter(paymentPlanOptions, (p) => {
    return p.autoBilling !== undefined;
  });

  return !isEmpty(paymentPlanOptionsExcludePayInFull) && every(
    paymentPlanOptionsExcludePayInFull,
    ({ autoBilling }) => autoBilling === false);
};

const isPaymentPlanMatched = (target, paymentPlanOptions) => {
  const newTarget = target.map(obj => `${obj.groupId}-${obj.paymentPlanId}`).sort();
  const newPaymentPlanOptions = paymentPlanOptions.map(obj => `${obj.groupId}-${obj.paymentPlanId}`).sort();

  if (newTarget.length !== newPaymentPlanOptions.length) {
    return false;
  }

  return newTarget.every((value, index) => value === newPaymentPlanOptions[index]);
};

export const matchPaymentCombination = (paymentCombinationGroups, {
  paymentOptionType,
  paymentMethodType,
  isUseCreditBalance,
  paymentPlanOptions,
}) => {
  const target = filter(paymentCombinationGroups[paymentOptionType], (p) => {
    return p.paymentMethodType === paymentMethodType && p.useCreditBalance === isUseCreditBalance;
  });
  if (paymentOptionType === 'PAY_DEPOSIT_WITH_PAYMENT_PLAN') {
    return filter(target, ({ paymentPlanIdAndGroups }) => {
      return isPaymentPlanMatched(paymentPlanIdAndGroups, paymentPlanOptions);
    })[0];
  }
  return target[0];
};
